<input
  pInputText
  [value]="value"
  (input)="onInputChange($event)"
  (blur)="onTouched()"
  [placeholder]="placeholder"
  class="form-input"
  />
@if (hasError) {
  <div class="error-message">{{ errorMessage | translate }}</div>
}
